{
  "$schema": "cai-design-tokens/1.0",
  "name": "CAI — Centre d'Alertes i Incidències",
  "source": "redisseny BAtech (cai-design/Main.dc.html)",
  "color": {
    "brand": { "default": "#15296E", "ink": "#0B1633", "soft": "#EEF1FA" },
    "navy": { "900": "#0B1633", "700": "#15296E", "500": "#3550B5", "50": "#EEF1FA" },
    "system": {
      "blue": "#15296E",
      "blueDark": "#3550B5",
      "green": "#12875A",
      "indigo": "#3550B5",
      "orange": "#C2580A",
      "pink": "#FF2D55",
      "purple": "#7A3FC2",
      "red": "#D92D20",
      "teal": "#0E7490",
      "yellow": "#FFCC00",
      "brown": "#A2845E",
      "mint": "#00C7BE"
    },
    "gray": {
      "1": "#8E8E93",
      "2": "#AEAEB2",
      "3": "#C7C7CC",
      "4": "#D1D1D6",
      "5": "#E5E5EA",
      "6": "#F2F2F7"
    },
    "label": {
      "primary": "#101828",
      "secondary": "#5B6478",
      "tertiary": "#98A2B3",
      "quaternary": "#D0D5DD"
    },
    "background": {
      "default": "#FFFFFF",
      "grouped": "#F4F6FB",
      "elevated": "#FFFFFF",
      "page": "#F4F6FB",
      "lock": "radial-gradient(circle at 50% 30%, #3a3a3c 0%, #1c1c1e 55%, #000000 100%)",
      "critic": "linear-gradient(170deg, #FF453A 0%, #D70015 58%, #8E0000 100%)"
    },
    "separator": { "default": "#E4E7EE", "opaque": "#D0D5DD" },
    "fill": {
      "primary": "#F1F2F5",
      "secondary": "#E9ECF3",
      "tertiary": "#F4F6FB"
    },
    "semantic": {
      "critic": "#D92D20",
      "incident": "#C2580A",
      "avis": "#0E7490",
      "preventiu": "#3550B5",
      "resolt": "#12875A",
      "crisi": "#7A3FC2"
    },
    "shiftGrid": {
      "titular": "#15296E",
      "substitut": "#DCE2F2",
      "crisi": "#7A3FC2",
      "buit": "repeating-linear-gradient(45deg, #FEF0E6 0 6px, #FFF8F2 6px 12px)"
    }
  },
  "badge": {
    "critic": { "bg": "#FDECEA", "fg": "#B42318" },
    "incident": { "bg": "#FEF0E6", "fg": "#A8490A" },
    "avis": { "bg": "#E3F4F7", "fg": "#0B5F75" },
    "preventiu": { "bg": "#EEF1FA", "fg": "#15296E" },
    "ok": { "bg": "#E6F5EE", "fg": "#0E6E49" },
    "crisi": { "bg": "#F1EAFB", "fg": "#6A33AD" },
    "gray": { "bg": "#F1F2F5", "fg": "#4A5263" },
    "solidCritic": { "bg": "#D92D20", "fg": "#FFFFFF" }
  },
  "statusBadge": {
    "CRITICA": "solidCritic",
    "EN_CURS": "incident",
    "CONFIRMADA": "ok",
    "PENDENT": "gray",
    "EXPIRADA": "critic",
    "LLIURAT": "avis",
    "LLEGIT": "preventiu",
    "FALLIT": "critic",
    "COBERT": "ok",
    "SENSE_COBERTURA": "critic",
    "RESOLTA": "ok",
    "MITIGADA": "preventiu",
    "CANCELLADA": "gray",
    "FINALITZADA": "ok",
    "GUARDIA_IT": "incident",
    "CRISI": "crisi",
    "AVIS": "avis",
    "INCIDENCIA": "incident",
    "PREVENTIU": "preventiu",
    "DOC_VIGENT": "ok",
    "DOC_EN_ANALISI": "incident",
    "DOC_BLOQUEJAT": "critic",
    "DOC_RETIRAT": "gray"
  },
  "radius": { "xs": 6, "s": 10, "m": 14, "l": 18, "xl": 24, "pill": 999 },
  "spacing": { "1": 4, "1_5": 6, "2": 8, "2_5": 10, "3": 12, "3_5": 14, "4": 16, "5": 20, "6": 24 },
  "shadow": {
    "1": "0 1px 2px rgba(16,24,40,.05)",
    "2": "0 4px 16px rgba(16,24,40,.08), 0 1px 3px rgba(16,24,40,.05)",
    "3": "0 18px 48px rgba(16,24,40,.16), 0 4px 12px rgba(16,24,40,.08)",
    "critic": "0 4px 18px rgba(217,45,32,.16)"
  },
  "font": {
    "family": {
      "sans": "\"Plus Jakarta Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
      "mono": "ui-monospace, \"SF Mono\", SFMono-Regular, \"JetBrains Mono\", Menlo, monospace"
    },
    "base": { "size": 15, "lineHeight": 1.45 },
    "scale": {
      "largeTitle": { "size": 34, "lineHeight": 41, "weight": 700, "letterSpacing": 0.37 },
      "title1": { "size": 28, "lineHeight": 34, "weight": 700, "letterSpacing": 0.36 },
      "title2": { "size": 22, "lineHeight": 28, "weight": 700, "letterSpacing": 0.35 },
      "title3": { "size": 20, "lineHeight": 25, "weight": 600, "letterSpacing": 0.38 },
      "headline": { "size": 17, "lineHeight": 22, "weight": 600, "letterSpacing": -0.41 },
      "body": { "size": 17, "lineHeight": 22, "weight": 400, "letterSpacing": -0.41 },
      "callout": { "size": 16, "lineHeight": 21, "weight": 400, "letterSpacing": -0.32 },
      "subhead": { "size": 15, "lineHeight": 20, "weight": 400, "letterSpacing": -0.24 },
      "footnote": { "size": 13, "lineHeight": 18, "weight": 400, "letterSpacing": -0.08 },
      "caption1": { "size": 12, "lineHeight": 16, "weight": 400, "letterSpacing": 0 },
      "caption2": { "size": 11, "lineHeight": 13, "weight": 400, "letterSpacing": 0.06 }
    }
  },
  "component": {
    "button": {
      "fontSize": 17,
      "fontWeight": 600,
      "paddingY": 13,
      "paddingX": 20,
      "radius": 14,
      "variants": ["primary", "secondary", "critic", "success", "ghost", "dark", "outline"],
      "sizes": ["default", "s", "xs"]
    },
    "tabbar": { "height": 78, "labelSize": 10, "active": "#15296E", "inactive": "#8E8E93" },
    "navbar": { "largeTitleSize": 32, "largeTitleLineHeight": 40 },
    "listRow": { "minHeight": 44, "iconSize": 29, "iconRadius": 7 },
    "avatar": { "s": 28, "m": 36, "l": 56, "xl": 76 },
    "cardCritic": {
      "borderWidth": 1.5,
      "borderColor": "#D92D20",
      "shadow": "0 4px 18px rgba(217,45,32,.16)"
    },
    "pushCritic": { "bg": "rgba(217,45,32,0.94)", "fg": "#FFFFFF" },
    "slideConfirm": {
      "height": 56,
      "radius": 999,
      "knobSize": 46,
      "knobBg": "#FFFFFF",
      "knobIcon": "#D92D20"
    },
    "webSidebar": { "width": 248, "bg": "#0B1633", "activeBg": "#15296E", "activeFg": "#FFFFFF" },
    "webToolbar": { "height": 56 },
    "webPanel": { "radius": 14, "border": "#E4E7EE", "shadow": "none" },
    "webContent": { "padding": 32 }
  }
}
